import api from './data.services'
import { AuthUserStatus } from '../models'
import { authService } from './'

const usersSrv = 'patients/pages'
const userSrv = 'patients/administrators'
const userCurrentSrv = 'patients'
const userStatusEnabledSrv = 'patients/administrators/confirm'
const userStatusDisabledSrv = 'patients/administrators/deny'
const userDeleteSrv = 'patients/administrators'
const userRecoveryPasswordSrv = 'auth/recover/passwords'
const userStatusSrv = 'status'
const userDocumentsTypesSrv = 'documents/types'
const userRolesSrv = 'roles/persons'
const userRegisterAdminSrv = 'patients/administrators'
const userRegisterPatientSrv = 'patients/administrators/patients'
const userUpdateSrv = 'patients/administrators'
const userImagesSrv = 'patients/photos/alls'
const userPasswordSrv = 'persons/passwords'
const userRegisteredSrv = 'patients/validations/registrations'
const userAgeValidateSrv = 'patients/validations/age'

const getUsers = async (filter: string = '', status: number = 0, page: number = 1, limit: number = 10) => {
  try {
    const resp: any = await api.post(
      usersSrv,
      {
        filter,
        status,
        page,
        limit
      },
      authService.getToken()
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener usuarios!'
    }
  }
}

const getUserById = async (userId: number) => {
  try {
    const resp: any = await api.get(`${userSrv}/${userId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.patient ? resp.data.patient : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener usuario!'
    }
  }
}

const getUserCurrent = async () => {
  try {
    const resp: any = await api.get(`${userCurrentSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.patient ? resp.data.patient : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener usuario!'
    }
  }
}

const getStatus = async () => {
  try {
    const resp: any = await api.get(`${userStatusSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.statusData ? resp.data.statusData : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener estatus!'
    }
  }
}

const getRoles = async () => {
  try {
    const resp: any = await api.get(`${userRolesSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.personRole ? resp.data.personRole : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener estatus!'
    }
  }
}

const getDocumentsTypes = async () => {
  try {
    const resp: any = await api.get(`${userDocumentsTypesSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.DocumentTypes ? resp.data.DocumentTypes : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener tipos de documentos!'
    }
  }
}

const getUserImages = async (userId: number) => {
  try {
    const resp: any = await api.get(`${userImagesSrv}/${userId}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.files ? resp.data.files : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener estatus!'
    }
  }
}

const getUserRegistered = async (typeDocumentId: number, documentNumber: string) => {
  try {
    const resp: any = await api.get(`${userRegisteredSrv}/${typeDocumentId}/${documentNumber}`)

    return {
      status: (resp?.status === 200 ? 'Ok' : 'Error'),
      message: (resp?.data?.msg)
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error?.msg ? error.msg : 'Error server al validar documento!')
    }
  }
}

const getUserAgeValidate = async (date: string) => {
  try {
    const resp: any = await api.get(`${userAgeValidateSrv}/${date}`)

    return {
      status: 'Ok',
      data: (resp.data ? resp.data : {})
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error?.msg ? error.msg : 'Error server al validar documento!')
    }
  }
}

const register = async (userData: FormData) => {
  try {
    const userRegisterSrv = (userData.get('person_role_id') === '1' ? userRegisterAdminSrv : userRegisterPatientSrv)
    const resp: any = await api.post(userRegisterSrv, userData, authService.getToken())

    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data && resp.data.patient ? resp.data.patient : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error: any) {
    return {
      status: 'Error',
      statusCode: error?.statusCode,
      error,
      message: (error && error.statusCode === 400 ? error?.errors[0]?.msg : 'Error server al registar usuario!')
    }
  }
}

const postUserRecoveryPassword = async (documentTypeId: number, documentNumber: string) => {
  try {
    const resp: any = await api.post(
      userRecoveryPasswordSrv,
      {
        document_type_id: documentTypeId,
        document_number: documentNumber
      },
      authService.getToken()
    )

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al enviar cambio de clave usuario!'
    }
  }
}

const updateUser = async (userData: FormData) => {
  try {
    const resp: any = await api.put(userUpdateSrv, userData, authService.getToken())

    if(resp) {
      return {
        status: 'Ok',
        data: (resp && resp.data && resp.data.patient ? resp.data.patient : [])
      }
    }

    return {
      status: 'Error',
      error: ''
    }
  } catch(error: any) {
    return {
      status: 'Error',
      statusCode: error?.statusCode,
      error,
      message: (error && error.statusCode === 400 ? error?.errors[0]?.msg : 'Error server al actualizar usuario!')
    }
  }
}

const updateUserStatus = async (id: number, status: AuthUserStatus) => {
  try {
    let resp: any

    if(status === 'ENABLED') {
      resp = await api.put(`${userStatusEnabledSrv}/${id}`, {}, authService.getToken())

    } else if(status === 'DISABLED') {
      resp = await api.put(`${userStatusDisabledSrv}/${id}`, {}, authService.getToken())

    } else {
      return {
        status: 'Error',
        data: [],
        message: 'Error al habilitar o deshabilitar usuario!'
      }
    }

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al habilitar o deshabilitar usuario!'
    }
  }
}

const updateUserCurrent = async (userData: FormData) => {
  try {
    const resp: any = await api.put(userCurrentSrv, userData, authService.getToken())

    if(resp && resp.status === 200) {
      return {
        status: 'Ok',
        data: (resp.data ? resp.data : {})
      }
    }

    return {
      status: 'Error',
      message: (resp && resp.response && resp.response.data && resp.response.data.errors ? resp.response.data.errors : '')
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al actualizar perfil')
    }
  }
}

const delUser = async (id: number) => {
  try {
    let resp: any = await api.del(userDeleteSrv, id, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al habilitar o deshabilitar usuario!'
    }
  }
}

const delUserCurrent = async () => {
  try {
    let resp: any = await api.del(userCurrentSrv, undefined, authService.getToken())

    if(resp && resp.status === 200) {
      return {
        status: 'Ok',
        data: (resp.data ? resp.data : {})
      }
    }

    return {
      status: 'Error',
      message: (resp && resp.response && resp.response.data && resp.response.data.errors ? resp.response.data.errors : '')
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al eliminar perfil')
    }
  }
}

const updateUserCurrentPassword = async (passwordsData: any) => {
  try {
    let resp: any = await api.put(userPasswordSrv, passwordsData, authService.getToken())

    if(resp && resp.status === 200) {
      return {
        status: 'Ok',
        data: (resp.data ? resp.data : {})
      }
    }

    return {
      status: 'Error',
      message: (resp && resp.response && resp.response.data && resp.response.data.errors ? resp.response.data.errors : '')
    }
  } catch(error: any) {
    return {
      status: 'Error',
      message: (error && error.msg ? error.msg : 'Error server al actualizar contraseña')
    }
  }
}

export const userService = {
  getUsers,
  getUserById,
  getUserCurrent,
  getStatus,
  getRoles,
  getDocumentsTypes,
  getUserImages,
  getUserRegistered,
  getUserAgeValidate,
  register,
  postUserRecoveryPassword,
  updateUserStatus,
  updateUser,
  updateUserCurrent,
  delUser,
  delUserCurrent,
  updateUserCurrentPassword
}